import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useFormikContext } from "formik";

export default function InventoryPlacementButton(props) {
  const { errors, submitCount } = useFormikContext();
  const showError = !!errors.shipmentItemQuantity && submitCount > 0;

  return (
    <>
      <Button fullWidth variant="outlined" color={showError ? "error" : "primary"} {...props}>
        Inventory Placement
      </Button>
      {showError && (
        <Typography color="error" variant="caption" sx={{ ml: 2, mt: 0.5, display: "block" }}>
          Required
        </Typography>
      )}
    </>
  );
}
